/**
 * Formats français partout : « 24/10/2026 15:59 », « 60 000 FCFA ».
 *
 * Beaucoup d'écrans appellent toLocaleString() ou Intl.NumberFormat() sans
 * préciser la langue : le navigateur prenait alors la sienne (souvent
 * l'anglais : « 10/24/2026, 3:59 PM », « 60,000 »). Sans langue indiquée,
 * c'est désormais le français.
 */
const LANGUE = 'fr-FR'

function avecLangue(proto, nom) {
  const original = proto[nom]
  if (!original || original.__francais) return
  const remplace = function (locales, options) {
    return original.call(this, locales ?? LANGUE, options)
  }
  remplace.__francais = true
  proto[nom] = remplace
}

avecLangue(Number.prototype, 'toLocaleString')
avecLangue(Date.prototype, 'toLocaleString')
avecLangue(Date.prototype, 'toLocaleDateString')
avecLangue(Date.prototype, 'toLocaleTimeString')

function constructeurFrancais(Original) {
  if (!Original || Original.__francais) return Original
  const Remplace = function (locales, options) {
    return new Original(locales ?? LANGUE, options)
  }
  Remplace.prototype = Original.prototype
  Remplace.supportedLocalesOf = Original.supportedLocalesOf
  Remplace.__francais = true
  return Remplace
}

Intl.NumberFormat = constructeurFrancais(Intl.NumberFormat)
Intl.DateTimeFormat = constructeurFrancais(Intl.DateTimeFormat)
